/**
 * This component has the same look and feel as the TabMenu component, though semantically it doesn't use tabs, but a plain old list of links.
 */
import React from 'react'
import { useTranslation } from 'react-i18next'

import NavMenuItem from './NavMenuItem'
import MenuWrapper from './styles/MenuWrapper'

type MenuItem = {
    label: string
    to?: string
    url?: string
    options?: MenuItem[]
    end?: boolean
}

const NavMenu = ({
    edgePadding,
    edgeMargin,
    showBorder,
    options,
    children,
    ...rest
}) => {
    const { t } = useTranslation()

    if (!options || !options.length) {
        return null
    }

    return (
        <MenuWrapper
            $edgePadding={edgePadding}
            $edgeMargin={edgeMargin}
            $showBorder={showBorder}
            as={'nav'}
            aria-label={t('entity-group.group-navigation')}
            {...rest}
        >
            {children}

            <ul className="MenuContainer">
                {options.map((item: MenuItem, i: number) => (
                    <li key={i}>
                        <NavMenuItem key={i} item={item} counter={i} />
                    </li>
                ))}
            </ul>
        </MenuWrapper>
    )
}

export default NavMenu
